import { render, staticRenderFns } from "./commentComponent.vue?vue&type=template&id=0662b996&scoped=true"
import script from "./commentComponent.vue?vue&type=script&lang=js"
export * from "./commentComponent.vue?vue&type=script&lang=js"
import style0 from "./commentComponent.vue?vue&type=style&index=0&id=0662b996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0662b996",
  null
  
)

export default component.exports